import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetOrderReport = (
  startDate: string,
  endDate: string,
  customerId: string | undefined,
  status: string,
  paymentStatus: string,
  fetchReport: boolean
) => {
  const token = getToken();

  return useQuery({
    queryKey: [
      "orderReport",
      startDate,
      endDate,
      customerId,
      paymentStatus,
      status,
      fetchReport,
    ],
    queryFn: async () => {
      if (!token || !startDate || !endDate) return;

      const params: Record<string, string> = { startDate, endDate };
      if (customerId) params.customerId = customerId;
      if (status) params.status = status;
      if (paymentStatus) params.paymentStatus = paymentStatus;

      const response = await axiosInstance.get("reports/orders", {
        headers: { Authorization: `Bearer ${token}` },
        params,
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      const fileNameParts = [`Betty_Order_Report_${startDate}_to_${endDate}`];
      if (customerId) fileNameParts.push(`Customer_${customerId}`);
      if (status) fileNameParts.push(`Status_${status}`);
      if (paymentStatus) fileNameParts.push(`PaymentStatus${paymentStatus}`);
      const fileName = `${fileNameParts.join("_")}.xlsx`;

      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true };
    },
    enabled: fetchReport,
  });
};
